import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CashOutCountriesList as country } from '../../pages/Cashouts/CashOutHelpers';
import { startCase, isUndefined, camelCase, toLower, isArray } from 'lodash';
import { LabelValue } from '../../components/common';
import { formatDateAs, formatDateUTCAs, DateFormats } from '../Dates';
import { amountFormatter } from './ListFormatters';
import { getCountryImage, getPaymentMethodImage } from '../Paths';

const pascalCase = (str) => str[0].toUpperCase() + camelCase(str.substr(1));
export const translate = (t, propertyName) => t(`label${pascalCase(propertyName)}`);
export const labelValueExternalReferenceFormatter = (propertyName, item, t) =>
  (item.country === country.JAPAN || item.country === country.INDIA) && item.providerExternalReference != null && labelValueFormatter(propertyName, item, t);

export const labelValueFormatter = (propertyName, item, t, image, className = '', useStartCase = false, handleErrorImg = null) => {
  const itemValue = isArray(item[propertyName]) ? item[propertyName].join([' \\ ']) : item[propertyName];
  return (
    <LabelValue
      className={className}
      key={`labelValue-${propertyName}`}
      label={translate(t, propertyName)}
      // eslint-disable-next-line no-nested-ternary
      value={isUndefined(itemValue) ? item : useStartCase ? startCase(toLower(itemValue)) : itemValue}
      image={image}
      handleErrorImg={handleErrorImg}
      useHorizontalRule
    />
  );
};

export const detailDateFormatter = (propertyName, item, t) => (
  <LabelValue key={`labelValue-${propertyName}`} label={translate(t, propertyName)} value={formatDateAs(item[propertyName], DateFormats.TextDate)} useHorizontalRule />
);

export const detailUTCDateFormatter = (propertyName, item, t) => (
  <LabelValue key={`labelValue-${propertyName}`} label={translate(t, propertyName)} value={formatDateUTCAs(item[propertyName], DateFormats.TextDate)} useHorizontalRule />
);

export const detailDateTimeFormatter = (propertyName, item, t) => (
  <LabelValue key={`labelValue-${propertyName}`} label={translate(t, propertyName)} value={formatDateAs(item[propertyName], DateFormats.TextDateTime)} useHorizontalRule />
);

export const detailDateOfBirthFormatter = (propertyName, item, t) => (
  <LabelValue key={`labelValue-${propertyName}`} label={translate(t, propertyName)} value={formatDateAs(item[propertyName], DateFormats.notifDate)} useHorizontalRule />
);

export const labelAmountFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, amountFormatter(item[propertyName], item.currency), t);
export const labelBankCodeFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, item.bankCodeName, t);
export const labelPlanFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, item.plan, t);
export const labelPlanUnitFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, item.planUnit, t);
export const labelInstallmentsFormatter = (propertyName, item, t) => item.allowInstallments && labelValueFormatter(propertyName, item.allowInstallments, t);
export const labelCountryFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, item.countryName || item.country, t, getCountryImage(item[propertyName]));
export const labelPaymentMethodFormatter = (propertyName, item, t) =>
  labelValueFormatter(propertyName, item.paymentMethodName || item.paymentMethod, t, getPaymentMethodImage(item[propertyName]));
export const highlightedLabelAmountFormatter = (propertyName, item, t) => labelValueFormatter(propertyName, amountFormatter(item[propertyName], item.currency), t, null, 'highlight');

export const iconFormatter = (values) =>
  values.map((v) => (
    <FontAwesomeIcon
      key={v}
      icon={{
        iconName: 'ellipsis-h',
        prefix: 'fas',
      }}
      className="icon-password"
      style={{ marginRight: '1px' }}
    />
  ));
export const labelValuePassword = (propertyName, item, t) => labelValueFormatter(propertyName, iconFormatter(Array.from(item[propertyName])), t);

export const cryptoFormatter = (propertyName, item, t) => {
  return (
    <>
      <LabelValue key={`labelValue-${propertyName}-currency`} label={translate(t, `${propertyName}-currency`)} value={item[propertyName].currency} useHorizontalRule />
      <LabelValue key={`labelValue-${propertyName}-wallet`} label={translate(t, `${propertyName}-wallet`)} value={item[propertyName].wallet} useHorizontalRule />
      <LabelValue key={`labelValue-${propertyName}-network`} label={translate(t, `${propertyName}-network`)} value={item[propertyName].network} useHorizontalRule />
    </>
  );
};
